"use strict";
/*

This file is generated from async/asyncTypes.ts

*/
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=../../../src/database/sync/types.js.map